export default __webpack_public_path__ + "static/media/cake_layer_one.0ec0ebdf.svg";